import type { Effect, Reducer, Subscription } from '@umijs/max';
import type { SingleUserType } from './data';
import { addUser, editUser, getUserPage, removeUser } from './service';

export type UserState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: SingleUserType[];
};

type UserModelType = {
  namespace: string;
  state: UserState;
  reducers: {
    UserReducer: Reducer<UserState>;
  };
  effects: {
    fetchUserPageEffect: Effect;
    refreshDataEffect: Effect;
    addUserEffect: Effect;
    editUserEffect: Effect;
    removeUserEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 通用操作处理函数
const createEffect = (serviceCall: any) =>
  function* (
    { payload: action, callback }: any,
    { call, put }: any,
  ): Generator<any, void, any> {
    try {
      const res: any = yield call(
        serviceCall,
        action.values || { id: action.id },
      );

      if (res && res.code === 0) {
        yield put({
          type: 'refreshDataEffect',
          payload: { ...action },
        });
      }

      callback?.(res);
    } catch (e) {}
  };

const UserModel: UserModelType = {
  namespace: 'user',
  state: {
    code: 0,
    type: '',
    message: 'success',
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    UserReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as UserState;
    },
  },

  effects: {
    *fetchUserPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getUserPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: 'UserReducer',
          payload: res,
        });
      } catch (e) {
        console.error('Fetch data failed:', e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.user.current);
      const pageSize = yield select((state: any) => state.user.pageSize);
      yield put({
        type: 'fetchUserPageEffect',
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },

    // 简化的 effects
    addUserEffect: createEffect(addUser),
    editUserEffect: createEffect(editUser),
    removeUserEffect: createEffect(removeUser),
  },

  subscriptions: {
    setup() {},
  },
};

export default UserModel;
